var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container"},[_c('div',{staticClass:"content"},[_c('notifications'),_vm._v(" "),_c('div',{},[_c('nuxt')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }